import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const services = [
  {
    id: 1,
    title: 'Pre-Purchase Advice',
    description: 'Make informed property decisions with our expert pre-purchase consultations. We assess potential properties for design feasibility, renovation costs, and development opportunities.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
  },
  {
    id: 2,
    title: 'Residential Design',
    description: 'Transform your vision into reality with our comprehensive residential design services. From new builds to renovations, we create functional and beautiful living spaces tailored to your lifestyle.',
    image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80',
  },
  {
    id: 3,
    title: 'Building Permits',
    description: 'Navigate the complex permit process with ease. Our team handles all documentation, council submissions, and approvals to ensure your project meets all regulatory requirements.',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
  },
  {
    id: 4,
    title: 'Town Planning',
    description: 'Expert town planning services to guide your development through council approval processes. We prepare comprehensive planning applications and represent your interests at council meetings.',
    image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=800&q=80',
  },
  {
    id: 5,
    title: 'Marketing Plans',
    description: 'Showcase your property developments with professional marketing materials. We create compelling visual presentations and documentation to attract buyers and investors.',
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
  },
  {
    id: 6,
    title: '3D Visualisation',
    description: 'Bring your designs to life with photorealistic 3D renders and virtual walkthroughs. Our visualisation services help you and stakeholders understand the final outcome before construction begins.',
    image: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&q=80',
  },
];

const Services = () => {
  return (
    <div className="services-page services-page-v2">
      {/* Hero Section with background image */}
      <section className="services-hero">
        <div 
          className="services-hero-bg"
          style={{ 
            backgroundImage: 'url(https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1920&q=80)' 
          }}
        />
        <div className="services-hero-overlay" />
        <div className="container">
          <motion.div 
            className="services-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="services-hero-title">Our Services</h1>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <div className="container">
          <div className="services-grid-v2">
            {services.map((service, index) => (
              <motion.div 
                key={service.id}
                className="service-card-v2"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="service-card-image">
                  <img src={service.image} alt={service.title} />
                </div>
                <div className="service-card-content">
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-description">{service.description}</p>
                  <Link to="/contact" className="service-card-link">
                    Learn more
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Marquee Section */}
      <section className="services-marquee">
        <div className="marquee-track">
          <span>VESTA DESIGNS STUDIO</span>
          <span>VESTA DESIGNS STUDIO</span>
          <span>VESTA DESIGNS STUDIO</span>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta-v2">
        <div className="container">
          <motion.h2 
            className="services-cta-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            Ready to bring your vision to life?
          </motion.h2>
        </div>
      </section>
    </div>
  );
};

export default Services;
